// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Debounce$PrezzeeRibbon from "./Debounce.bs.js";

function useWindowSize(debounceTime, param) {
  var match = React.useState(function () {
        return {
                width: 0,
                height: 0
              };
      });
  var setWindowSize = match[1];
  React.useEffect((function () {
          var handleWindowResize = function (param) {
            Curry._1(setWindowSize, (function (param) {
                    return {
                            width: window.innerWidth,
                            height: window.innerHeight
                          };
                  }));
          };
          var handleResizeFn = debounceTime !== undefined ? Debounce$PrezzeeRibbon.make(debounceTime, handleWindowResize) : handleWindowResize;
          window.addEventListener("resize", handleResizeFn);
          Curry._1(setWindowSize, (function (param) {
                  return {
                          width: window.innerWidth,
                          height: window.innerHeight
                        };
                }));
          return (function (param) {
                    window.removeEventListener("resize", handleResizeFn);
                  });
        }), []);
  return match[0];
}

export {
  useWindowSize ,
}
/* react Not a pure module */
